/**
 * Model choices offered by the automation steps that call an LLM.
 *
 * Extracted from `EvaluateStepConfig` so a second step can offer the same
 * choices without duplicating the list. Labels are product names; callers pass
 * them through `t()` at render time like any other displayed string.
 */

export interface LlmModelOption {
	value: string;
	label: string;
}

/** Anthropic (Claude) models offered by the "Process with AI" step. */
export const ANTHROPIC_MODEL_OPTIONS: Array<LlmModelOption> = [
	{ value: 'claude-sonnet-4-20250514', label: 'Claude Sonnet 4' },
	{ value: 'claude-3-5-sonnet-20241022', label: 'Claude 3.5 Sonnet' },
	{ value: 'claude-3-opus-20240229', label: 'Claude 3 Opus' },
	{ value: 'claude-3-haiku-20240307', label: 'Claude 3 Haiku' },
];

/** OpenAI models offered by the "Process with AI" step. */
export const OPENAI_MODEL_OPTIONS: Array<LlmModelOption> = [
	{ value: 'gpt-4o', label: 'GPT-4o' },
	{ value: 'gpt-4o-mini', label: 'GPT-4o Mini' },
	{ value: 'gpt-4-turbo', label: 'GPT-4 Turbo' },
	{ value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' },
];

/**
 * The model a step uses when its config leaves the choice unset.
 *
 * Mirrors `DEFAULT_TASK_MODEL` in
 * `apps/crm-api/src/modules/email-ingest/services/anthropic-task.service.ts`.
 * It is surfaced so the form can name the default instead of showing an empty
 * control — an unset value still means "whatever the server defaults to", which
 * is what keeps the two in step when the server default moves.
 */
export const DEFAULT_TASK_MODEL_OPTION: LlmModelOption = {
	value: 'claude-sonnet-5',
	label: 'Claude Sonnet 5',
};
